/*
 * DW-START — Collection page star ratings (implemented, disabled by default)
 *
 * Master switch: GET /api/settings/public -> { show_ratings_on_collections: bool }
 * Controlled from the reviews admin panel (/admin -> Settings tab), same toggle
 * that already existed there unused. As long as that returns false (the default),
 * this script makes zero further network calls and injects nothing into the page.
 *
 * When enabled: batches all visible product IDs on the page into as few calls as
 * possible to /api/reviews/summary, and fills in a star rating + review count
 * under the title of any product card that has at least one approved review.
 * Products with zero reviews are left untouched — no empty stars, no "(0)".
 *
 * Star rendering matches the product page's review widget exactly (assets/dw-new-reviews.js):
 * gold Unicode ★/☆ glyphs in #c9a96e, not the theme's native black .rating-star component,
 * so collection-page ratings look identical to product-page ratings.
 *
 * Depends on:
 *  - data-dw-product-id attribute on the card wrapper (snippets/card-product.liquid)
 *  - empty data-dw-rating-slot div under the title (snippets/card-product.liquid)
 */
(function () {
  'use strict';

  var WORKER_URL = 'https://dw-reviews-worker.charlesudeh4real.workers.dev';
  var STYLE_ID = 'dw-collection-rating-style';

  function injectStyleOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.dw-collection-rating{display:flex;align-items:center;gap:6px;margin:2px 0 4px}' +
      '.dw-collection-rating:empty{margin:0}' +
      '.dw-collection-rating__stars{color:#c9a96e;font-size:12px;letter-spacing:1px}' +
      '.dw-collection-rating__count{font-size:1.1rem;color:rgb(var(--color-foreground),.75)}';
    document.head.appendChild(style);
  }

  function starGlyphs(score) {
    var n = Math.round(parseFloat(score) || 0);
    if (n < 0) n = 0;
    if (n > 5) n = 5;
    var s = '';
    for (var i = 0; i < 5; i++) s += (i < n ? '★' : '☆');
    return s;
  }

  function renderStars(slot, summary) {
    if (!slot || !summary || !summary.count) return;
    injectStyleOnce();
    slot.innerHTML =
      '<span class="dw-collection-rating__stars">' + starGlyphs(summary.average) + '</span>' +
      '<span class="dw-collection-rating__count">(' + summary.count + ')</span>';
  }

  function loadRatings(slots) {
    var idToSlot = {};
    var ids = [];
    slots.forEach(function (slot) {
      var card = slot.closest('[data-dw-product-id]');
      if (!card) return;
      var pid = card.getAttribute('data-dw-product-id');
      if (!pid || idToSlot[pid]) return;
      idToSlot[pid] = slot;
      ids.push(pid);
    });
    if (!ids.length) return;

    var chunks = [];
    for (var i = 0; i < ids.length; i += 50) chunks.push(ids.slice(i, i + 50));

    chunks.forEach(function (chunk) {
      fetch(WORKER_URL + '/api/reviews/summary?product_ids=' + chunk.join(','))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          Object.keys(data || {}).forEach(function (pid) {
            renderStars(idToSlot[pid], data[pid]);
          });
        })
        .catch(function () { /* silent — a failed batch just leaves those cards without a rating */ });
    });
  }

  function init() {
    var slots = document.querySelectorAll('[data-dw-rating-slot]');
    if (!slots.length) return;

    fetch(WORKER_URL + '/api/settings/public')
      .then(function (r) { return r.json(); })
      .then(function (settings) {
        if (!settings || settings.show_ratings_on_collections !== true) return;
        loadRatings(Array.prototype.slice.call(slots));
      })
      .catch(function () { /* master switch check failed — stay silent, no ratings */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* DW-END */
